  import React, { useEffect, useMemo, useRef, useState } from "react";
  import { SERVER_BASE } from "../config/server";
  import "bootstrap/dist/css/bootstrap.min.css";
  import InventoryModal from "./InventoryModal";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
  import apiClient from "../utils/apiClient";
  import Select from "react-select";
  import moment from "moment";
  import Swal from "sweetalert2";
  import { useLocation, useNavigate } from "react-router-dom";
  import { logDOM } from "@testing-library/react";

  const DepartmentReceiptVoucher = ({ setUnsavedChanges, accessOfDepartments }) => {
    const [activeTab, setActiveTab] = useState("receiptInfo");
    const [isLoading, setIsLoading] = useState(false);
    const centerCode = localStorage.getItem("code");
    const name = localStorage.getItem("name");
    const badgeId = localStorage.getItem("badgeId");
    const sewadarId = localStorage.getItem("sewadarId");
    const [isReturnable, setIsReturnable] = useState(true);
    const [inventoryOptions, setInventoryOptions] = useState([]);
    const token = localStorage.getItem("token");
    const code = localStorage.getItem("code");
    const [ledgerOptions, setLedgerOptions] = useState([]);
    const [purposeOptions, setPurposeOptions] = useState([]);
    const [projectOptions, setProjectOptions] = useState([]);
    const [TranportersOptions, setTranportersOptions] = useState([]);
    const [securitySewadars, setSecuritySewadars] = useState([]);
    const [gsrsOptions, setGsrsOptions] = useState([]);
    const [departments, setDepartments] = useState([]);
    const navigate = useNavigate();
    const sewadarOf = localStorage.getItem("sewadarOf");
    const role = localStorage.getItem("role");
    const [ledgerGroups, setLedgerGroups] = useState([]);
    const [CameFromGroup, setCameFromGroup] = useState("");
    const [documentOptions, setDocumentOptions] = useState([]);
    const [seriesRange, setSeriesRange] = useState(null);
    const [isDocumentNoInvalid, setIsDocumentNoInvalid] = useState(false);
    const [isSeriesAvailable, setIsSeriesAvailable] = useState(true);
  const purposeInitialized = useRef(false);



    const [formData, setFormData] = useState({
      srDate: "",
      date: new Date().toISOString().split("T")[0], // Prefill with today's date,
      ledgerName: "",
      ledger: "",
      purpose: "",
      vehicleNo: "",
      name: "",
      mobileNo: "",
      receivedGoods: "",
      centerCode: centerCode,
      onAccount: "",
      returnable: false,
      gsrsNo: null,
      consolidatedRemarks: "",
      cameFrom: null,
      sewadarSangatMobile: "", // New field for mobile
      siNo:"",
      documentNo:"",
      documentDate:""
    });
    const location = useLocation();
    const voucherData = location.state?.voucher;

    const isClone = location.state?.isClone || false;

    const [hasInitialized, setHasInitialized] = useState(false);

    const onAccountOptions = [
      { value: "Regular", label: "Regular" },
      // { value: "Visit", label: "Visit" },
      { value: "AHQ", label: "AHQ" },
      { value: "Project", label: "Project" },
    ];

    const returnableOptions = [
      { value: 1, label: "Yes" },
      { value: 0, label: "No" },
    ];

    useEffect(() => {
      if(voucherData?.srDate)
      fetchGsrsOptions(voucherData?.srDate);
    }, [voucherData?.srDate]);

    useEffect(() => {
      if (isClone) {
        setFormData((prev) => ({
          ...prev,
          srDate: "",
          gsrsNo: null,
          cameFrom: null,
          ledger: null,
          ledgerName: "",
          purpose: null,
          onAccount: null,
          selectedProjects: [],
          receivedGoods: "",
          consolidatedRemarks: "",
          vehicleNo: "",
          driverName: "",
          mobileNo: "",
          entryDate: "",
          entryTime: "",
          documentNo: null,
          documentDate: "",
        }));
      }
    }, [isClone]);
    useEffect(() => {
      if (!sewadarOf) return;
    
      const fetchSeriesRange = async () => {
        try {
          const res = await apiClient.get(
            `${SERVER_BASE}/getSeriesByDepartment`,
            {
              params: { departmentName: sewadarOf },
              headers: { Authorization: `Bearer ${token}` },
            }
          );
    
          setSeriesRange(res.data); // { startingNo, endingNo }
          setIsSeriesAvailable(true); // ✅ enable input
        } catch (err) {
          console.error("No series for department", err);
          setSeriesRange(null);
          setIsSeriesAvailable(false); // 🔒 disable input
        }
      };
    
      fetchSeriesRange();
    }, [sewadarOf]);
    
    useEffect(() => {
      if (
        voucherData  &&
        ledgerGroups.length > 0 &&
        !hasInitialized
      ) {
        setIsLoading(true);
  

      
        const ledgerGroup = ledgerGroups.find(
          (group) => group.value == voucherData?.cameFrom
        )?.value;

        const foundOnAccount = onAccountOptions.find(
          (opt) => opt.value == voucherData.onAccount
        );
        const selectedProjectIds = voucherData.selectedProjects
        ?.split(",")
        .map((id) => Number(id.trim()));
        const selectedProjects = projectOptions?.filter((opt) =>
          selectedProjectIds?.includes(opt.value)
        );
        if (voucherData?.purposeId) {
    fetchPurposeByLedger(ledgerGroup || voucherData.cameFrom).then(() => {
      setFormData((prev) => ({
        ...prev,
        purpose: {
          value: voucherData.purposeId,
          label: voucherData.purposeName,
        },
      }));
    });
  }
        if (isClone) {
          setFormData((prev) => ({
            ...prev,
            srDate: voucherData?.srDate,
            cameFrom: ledgerGroup,
            ledgerName: voucherData?.ledgerName,
            consolidatedRemarks: voucherData?.consolidatedRemarks,
            onAccount: foundOnAccount,
            receivedGoods: voucherData?.inventory || "",
            selectedProjects: selectedProjects,
          }));
              // ONLY Clone inventory -----------------
              if (voucherData?.items?.length > 0) {
                const rows = voucherData.items.map((item, index) => ({
                  id: index + 1,
                  item: item.itemId || "",
                  department: item.departmentName,
                  challanQty: item.challanQty || "",
                  recdQty: item.receivedQty || "",
                  difference: item.difference || "",
                  uom: item.uom || "",
                  remarks: item.remarks || "",
                  returnable: item.returnable || 0,
                  isFromVoucherData: true,
                }));
                setInventoryRows(rows);
              }
          
              setHasInitialized(true);
              setIsLoading(false);
              return; // STOP here – do not fill receipt info
              }

        // First set the cameFrom to trigger ledger fetch
        setFormData((prev) => ({
          ...prev,
          srDate: voucherData?.srDate,
          cameFrom: ledgerGroup,
          ledgerName: voucherData?.ledgerName,
          sewadarSangatMobile: voucherData?.sewadarSangatMobile,
          vehicleNo: voucherData?.vehicleNo || "",
          name: voucherData?.name || "",
          mobileNo: voucherData?.mobileNo || "",
          receivedGoods: voucherData?.inventory || "",
          centerCode: voucherData?.centerCode || centerCode,
          returnable: voucherData?.returnable == 1,   
          consolidatedRemarks: voucherData?.consolidatedRemarks,
          driverName: voucherData?.driverName,
          documentNo:voucherData?.documentNo,
          documentDate:voucherData?.documentDate,
          onAccount: foundOnAccount,
          selectedProjects: selectedProjects,
        }));

        // Set inventory rows
        if (voucherData?.items?.length > 0) {
          const rows = voucherData.items.map((item, index) => ({
            id: index + 1,
            item: item.itemId || "",
            department: item.departmentName,
            challanQty: item.challanQty || "",
            recdQty: item.receivedQty || "",
            difference: item.difference || "",
            uom: item.uom || "",
            remarks: item.remarks || "",
            returnable: item.returnable || 0,
            isFromVoucherData: true,

          }));
          setInventoryRows(rows);
        }



        setHasInitialized(true);
        setIsLoading(false);
      }
    }, [voucherData, gsrsOptions, hasInitialized, ledgerGroups,projectOptions]);
    // Add this useEffect to set the ledger once options are available
    useEffect(() => {
      if (
        voucherData &&
        onAccountOptions.length > 0 &&
        formData.cameFrom &&
        !formData.ledger
      ) { 
        const foundLedger = ledgerOptions.find(
          (led) => led.value == voucherData.ledgerId
        );
        const foundOnAccount = onAccountOptions.find(
          (opt) => opt.value == voucherData.onAccount
        );

        if (foundLedger) {
          setFormData((prev) => ({
            ...prev,
            ledger: foundLedger,
          }));

          // Fetch purpose and projects for this ledger
          fetchPurposeByLedger(foundLedger.group);
        
            fetchProjectsByLedger(foundLedger.value);
        }
      }

    }, [ledgerOptions, voucherData, formData.cameFrom, onAccountOptions]);

    const fetchLedgerGroups = async () => {
      try {
        setIsLoading(true);
        const response = await apiClient.get(`${SERVER_BASE}/ledger-groups`, {
          params: { code },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        // Convert API data to React Select format
        const options = response.data.map((option) => ({
          value: option.groupName,
          label: option.groupName,
        }));

        setLedgerGroups(options);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching ledger groups:", error);
      }
    };

    const fetchGsrsOptions = async (selectedDate) => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getGsrsData`, {
          params: {
            centerCode,
            isEdit: (voucherData && !isClone) ? true : false,
            srDate: selectedDate,
          }, // or any other filters
        });

        const options = response.data.map((entry) => ({
          value: entry.id,
          label: entry.gsrs, // assuming column name is gsrsNo
          badgeId: entry.badgeId,
          sewadarName: entry?.sewadarName,
          sewadarMobileNo: entry?.sewadarMobileNo,
          sewadarAlternateMob: entry?.sewadarAlternateMob,
          // documentNo:entry?.documentNo,
          // documentDate:entry?.documentDate,
          vehicleNo: entry?.vehicleNumber,
          driverName: entry?.driverName,
          mobileNo: entry?.mobileNo,
          entryDate: entry?.entryDate,
          entryTime: entry?.entryTime,
          cameFrom: entry?.cameFrom,
          ledgerId: entry?.ledgerName,
          bills: entry?.bills || [], // 🔹 keep bills nested
          siNo:entry?.siCode
        }));

        setGsrsOptions(options);
      } catch (error) {
        console.error("Failed to fetch GSRS options:", error);
      }
    };

    useEffect(() => {
      fetchLedgerGroups();
    }, []);
  const fetchSewadars = async () => {
    const departments = "Security,Satsang,Office";

    const res = await apiClient.get(
      `${SERVER_BASE}/getOperatorsByDepartment/${code}?department=${departments}`
    );

    setSecuritySewadars(res.data);
  };
    useEffect(() => {
      fetchSewadars();
    }, [code]);

    const goodsOptions = [
      { value: "Received as Transfer", label: "Received as Transfer " },
      {
        value: "Now, received on Returnable Basis ",
        label: "Now, received on Returnable Basis ",
      },
      {
        value: "Earlier Sent on Returnable Basis",
        label: "Earlier Sent on Returnable Basis",
      },
      {
        value: "Received as Condemned Inventory",
        label: "Received as Condemned Inventory ",
      },
      {
        value: "Received for Exchange",
        label: "Received for Exchange ",
      },{
        value: "Purchase",
        label: "Purchase ",
      },
    ];

    useEffect(() => {
      if (formData.receivedGoods) {
        let returnableValue = 0;
        let disableReturnable = false;

        if (formData.receivedGoods === "Earlier Sent on Returnable Basis") {
          returnableValue = 0;
          disableReturnable = true;
        } else if (
          formData.receivedGoods === "Now, received on Returnable Basis "
        ) {
          returnableValue = 1;
          disableReturnable = true;
        }
        // else case (Received as Transfer) remains 0 and editable

        // Update all rows' returnable status
        setInventoryRows((prevRows) =>
          prevRows.map((row) => ({
            ...row,
            returnable: returnableValue,
            disableReturnable, // Add this flag to each row
          }))
        );
      }
    }, [formData.receivedGoods]);

    const [inventoryRows, setInventoryRows] = useState([
      {
        id: 1,
        item: "",
        department: "",
        challanQty: "",
        recdQty: "",
        difference: "",
        uom: "",
        remarks: "",
        returnable: 0,
      },
    ]);
    const getFilteredInventoryOptions = (departmentValue) => {
      if (!departmentValue) return inventoryOptions; // Show all if no department selected

      return inventoryOptions.filter((item) => {
        // Check if item's departments includes the selected department
        return item.departments?.includes(departmentValue);
      });
    };

    const handleRowChange = (id, field, value) => {
      setInventoryRows((prevRows) =>
        prevRows.map((row) => {
          if (row.id == id) {
            const updatedRow = { ...row };

            // Handle value assignment (for both object and primitive values)
            updatedRow[field] = value?.value ?? value;

            // Handle department change
            if (field === "department") {
              const newDeptValue = value?.value ?? value;
              const currentDeptValue = row.department?.value ?? row.department;

              if (newDeptValue !== currentDeptValue) {
                updatedRow.item = null;
                updatedRow.uom = "";
              }
            }

            // Handle item change
            if (field === "item") {
              const selectedInventory = value
                ? inventoryOptions.find(
                    (opt) => opt.value == (value?.value ?? value)
                  )
                : null;
              updatedRow.uom = selectedInventory?.uom ?? "";
            }

            return updatedRow;
          }
          return row;
        })
      );
    };
    useEffect(() => {
      setInventoryRows((prev) =>
        prev.map((row) => {
          const diff =
            row.challanQty && row.recdQty
              ? parseFloat(row.challanQty) - parseFloat(row.recdQty)
              : "";
          return { ...row, difference: diff };
        })
      );
    }, [inventoryRows.map((r) => `${r.challanQty}-${r.recdQty}`).join(",")]);

    useEffect(() => {
      if (centerCode) {
        fetchInventory();
      }
    }, [centerCode]);

    useEffect(() => {
      if (accessOfDepartments) {
        const deptArray = accessOfDepartments
          .split(",")
          .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
        setDepartments(deptArray);
      }
    }, [accessOfDepartments]);

    const fetchInventory = async () => {
      try {
        const response = await apiClient.get(
          SERVER_BASE + "/getReceiptInventory",
          {
            params: { code: centerCode },
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
          }
        );
        const options = response.data.map((inventory) => ({
          value: inventory.id, // Adjust based on API response structure
          label: `${inventory.printName} ${
            inventory.aliasNames ? ` - [ ${inventory.aliasNames} ]` : ""
          }`,
          printName:inventory.printName,
          aliasNames: inventory.aliasNames,
          quantity: inventory.quantity,
          uom: inventory.uom,
          itemName: inventory.itemName,
          departments: inventory.departments,
        }));
        setInventoryOptions(options);
      } catch (error) {
        console.error("Error fetching purposes:", error);
      }
    };
    // Add a new inventory row
    const addRow = () => {
      let returnableValue = 0;
      let disableReturnable = false;

      if (formData.receivedGoods === "Earlier Sent on Returnable Basis") {
        returnableValue = 0;
        disableReturnable = true;
      } else if (
        formData.receivedGoods === "Now, received on Returnable Basis "
      ) {
        returnableValue = 1;
        disableReturnable = true;
      }

      const newRow = {
        id: Date.now(),
        department:
          voucherData &&
          ((voucherData?.createdBy != sewadarId && role == "Main Incharge") ||
            role == "Approver")
            ? sewadarOf
            : "",
        item: "",
        returnable: returnableValue,
        disableReturnable,
        challanQty: "",
        recdQty: "",
        uom: "",
        remarks: "",
        isNew: true,
      };

      setInventoryRows([...inventoryRows, newRow]);
    };
    // Delete a row
    const deleteRow = (id) => {
      if (inventoryRows.length > 1) {
        setInventoryRows(inventoryRows.filter((row) => row.id !== id));
        setUnsavedChanges(true);
      } else {
        alert("At least one row must remain.");
      }
    };

    const handleChallanChange = (field, value) => {
      setFormData((prevInfo) => {
    
  if (field === "cameFrom") {
    const cameFromValue = value?.value || null;

    const updatedInfo = {
      ...prevInfo,
      cameFrom: cameFromValue,
      purpose: null,
      ledger: null,
      ledgerName: null,
    };

    // 🔥 FETCH PURPOSE HERE (ONLY PLACE)
    if (
      cameFromValue == "Sewadar" ||
      cameFromValue == "Sangat" ||
      cameFromValue == "Not Known"
    ) {
      fetchPurposeByLedger(cameFromValue);
    }

    return updatedInfo;
  }

      if (field === "ledger") {
    const updatedInfo = {
      ...prevInfo,
      ledger: value,
      purpose: null,
    };

    if (value?.group) {
      fetchPurposeByLedger(value.group);
    }

    return updatedInfo;
  }


        if (field == "transporterName") {
          if (!value) {
            return {
              ...prevInfo,
              transporterName: null,
              transporterGSTIN: "",
            };
          }

          const selectedTransporter = TranportersOptions.find(
            (option) => option.value === value.value
          );
          return {
            ...prevInfo,
            transporterName: value,
            transporterGSTIN: selectedTransporter?.gstin || "",
          };
        }
        // ---------------- Bill / Inward Memo No. ----------------


        return { ...prevInfo, [field]: value };
      });

      setUnsavedChanges(true);
    };
    const fetchProjectsByLedger = async (ledgerId) => {
      try {
        const res = await apiClient.get(`${SERVER_BASE}/area-projects`);
        const options = res.data.map((proj) => ({
          value: proj.id,
          label: `${proj.projectName ? `${proj.projectName}` : ""} ${
            proj.projectCode ? `- [ Code :${proj.projectCode} ]` : ""
          } ${proj.approvalNo ? `- [ Approval No: ${proj.approvalNo} ]` : ""} ${
            proj.approvalDate
              ? `- [ Date : ${
                  proj.approvalDate
                    ? moment(proj.approvalDate).format("DD-MMM-YY")
                    : ""
                } ]`
              : ""
          }`,
        }));
        setProjectOptions(options);
      } catch (err) {
        console.error("Failed to load projects", err);
      }
    };
    useEffect(() => {
      fetchProjectsByLedger();
    }, []);
    const fetchPurposeByLedger = async (ledgerGroup) => {
      try {
        const response = await apiClient.get(
          SERVER_BASE + "/getPurposeByLedgerForChallan",
          {
            params: { ledgerName: ledgerGroup, code: centerCode, type: "rv" },
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
          }
        );

        const options = response.data.map((purpose) => ({
          value: purpose.id, // Adjust based on API response structure
          label: purpose.purposeName,
        }));
        setPurposeOptions(options);
      } catch (error) {
        console.error("Error fetching purposes:", error);
      }
    };
    useEffect(() => {
      // Fetch ledger details when cameFrom changes OR when initializing with voucherData
      if (formData?.cameFrom || voucherData?.cameFrom) {
        fetchledgermasterdetails();
      }
    }, [formData?.cameFrom, voucherData?.cameFrom]); // Add voucherData.cameFrom as dependency
    const firstCallDone = useRef(false);

    // Update the fetchledgermasterdetails function
    const fetchledgermasterdetails = async () => {
      try {
        setIsLoading(true);

        // Use formData.cameFrom if available, otherwise fall back to voucherData.cameFrom
        const ledgerSource = formData?.cameFrom || voucherData?.cameFrom;

        if (!ledgerSource) {
          setIsLoading(false);
          return;
        }

        const response = await apiClient.get(
          SERVER_BASE + "/getLedgerMasterByLedger",
          {
            params: { code, ledgerName: ledgerSource },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const options = response.data.map((ledger) => ({
          value: ledger?.id,
          label: ledger?.printName,
          group: ledger?.ledgerGroup,
          address: ledger?.address,
          gstin: ledger?.gstin,
          state: ledger?.state,
          stateCode: ledger?.stateCode,
          areaJurisdiction: ledger?.areaJurisdiction,
          ledgerGroupCode: ledger?.ledgerGroupCode,
          centerType: ledger?.centerType,
        }));

        setLedgerOptions(options);
      } catch (error) {
        console.error("Error fetching ledger master details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const showErrorToast = (message) => {
      Swal.fire({
        text: message,
        icon: "error",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    };

    const handleSubmit = async (type) => {
      const isFinal = type == "Verification Pending";
      // Validate required fields

      if (isFinal && !formData?.documentNo && !voucherData?.documentNo) {
        return showErrorToast("Inward Memo No is required!");
      }
      if (isFinal && (formData?.cameFrom != "Sewadar" && formData?.cameFrom != "Sangat" ) && !formData.ledger) {
        return showErrorToast("Ledger is required!");
      }
    

      if (isFinal && !formData.purpose) {
        return showErrorToast("Purpose is required!");
      }
      if (isFinal && !formData?.onAccount) {
        return showErrorToast("On Account is required!");
      }


      if (
        isFinal &&
        formData.onAccount?.value != "Project" &&
        !formData?.receivedGoods
      ) {
        return showErrorToast("Inventory is required");
      }
      if (
        isFinal &&
        formData.onAccount?.value == "Project" &&
        formData?.selectedProjects.length == 0
      ) {
        return showErrorToast("Project is required");
      }
      // ✅ Only run these validations if it's NOT a draft
      if (isFinal) {
        // Check each row individually
        for (let i = 0; i < inventoryRows.length; i++) {
          const row = inventoryRows[i];
          if (!row.department) {
            showErrorToast(`Row ${i + 1}: Please select department.`);
            return false;
          }
          if (!row.item) {
            showErrorToast(`Row ${i + 1}: Please select item.`);
            return false;
          }
        }
      }

      const submissionData = {
        srDate: formData?.srDate,
        date: formData.date,
        ledgerId:
          formData.cameFrom == "Sewadar" || formData.cameFrom == "Sangat"
            ? null
            : formData.ledger?.value || null,
        ledgerName:
          formData.cameFrom == "Sewadar" || formData.cameFrom == "Sangat"
            ? formData.ledgerName
            : formData.ledger?.label || null,
        purposeId: formData.purpose?.value || null,
        purposeName: formData.purpose?.label || null,
        vehicleNo: formData.vehicleNo,
        name: formData.name,
        mobileNo: formData.mobileNo,
        receivedGoods: formData.receivedGoods,
        centerCode: formData.centerCode,
        onAccount: formData.onAccount?.value || null,
        returnable: formData.returnable,
        gsrsId: formData.gsrsNo?.value || null,
        gsrsNo: formData.gsrsNo?.label || null,
        documentNo: formData.documentNo || voucherData?.documentNo,
        documentDate: formData.documentDate?moment(formData.documentDate).format('YYYY-MM-DD'):voucherData?.documentDate?moment(voucherData.documentDate).format('YYYY-MM-DD'):"",
        badgeId: formData?.badgeId,
        sewadarName: formData.sewadarName,
        sewadarMobile: formData.sewadarMobileNo,
        sewadarAlternateMobile: formData.sewadarAlternateMob,
        driverName: formData.driverName,
        driverMobile: formData.mobileNo,
        entryDate: formData.entryDate,
        entryTime: formData.entryTime,
        sewadarSangatMobile: formData.sewadarSangatMobile || null,
        cameFrom: formData?.cameFrom,
        type,
        consolidatedRemarks: formData?.consolidatedRemarks,
        receiptStatus: isFinal ? "Verification Pending" : "Draft at user level",
        createdBy: sewadarId,
        updatedBy: sewadarId,
        code: code,
        voucherType:'DR',
        seriesId: seriesRange?.id || null,
        inventoryItems: inventoryRows.map((row) => {
          // Find matching item from voucherData (if it exists)
          const originalItem = voucherData?.items?.find(
            (item) =>
              // Match by itemId if this is an existing row
              item.itemId == row.item || null
          );

          return {
            id: originalItem?.dbId || null, // Include original ID if exists
            receiptVoucherId: voucherData?.id || null,
            itemId: row.item,
            itemName:
              inventoryOptions.find((dep) => dep.value == row.item)?.printName || "",
            departmentId: row.department,
            departmentName:
              departments.find((dep) => dep.value == row.department)?.label || "",
            challan_qty: row.challanQty,
            received_qty: row.recdQty,
            difference: row.difference,
            uom: row.uom,
            remarks: row.remarks,
            returnable: row.returnable,
          };
        }),
        projects:formData.selectedProjects?.map((proj) => proj.value)?.join(",") || null,
      };

      try {
        if (voucherData && !isClone) {
          // 🔁 UPDATE existing voucher
          await apiClient.put(
            `${SERVER_BASE}/UpdateReceiptVoucher/${voucherData.id}`,
            submissionData,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } else {
          // ➕ CREATE new voucher
          await apiClient.post(
            `${SERVER_BASE}/SaveReceiptVoucher`,
            submissionData,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }

        Swal.fire({
          title: "Success",
          text: isFinal
            ? "Final submission successful!"
            : "Draft saved successfully!",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          navigate("../ReceiptVoucherList");
        });

        setUnsavedChanges(false);
      } catch (error) {
        console.error("Submission error:", error);
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Something went wrong",
          icon: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3500,
          timerProgressBar: true,
        });
      }
    };
    const handleDepartmentApproval = async (action) => {
      if (!voucherData?.id) {
        return showErrorToast("No voucher selected");
      }

      // Filter only the rows that are visible (belong to this department)
      const visibleRows = inventoryRows
        .filter((row) => {
          if (role == "Authorized Person") {
            return true; // Show all rows for Authorized Person
          } else {
            return row.department == sewadarOf; // Show only department rows for others
          }
        })
        .map((row) => ({
          itemId: row.item,
          itemName:
            inventoryOptions.find((dep) => dep.value == row.item)?.label || "",
          challanQty: row.challanQty || 0,
          recdQty: row.recdQty || 0,
          remarks: row.remarks,
          departmentId: row.department,
          difference: parseFloat(row?.challanQty) - parseFloat(row?.recdQty),
          uom: row.uom,
          returnable: row.returnable,
        }));

      try {
        const response = await apiClient.put(
          `${SERVER_BASE}/update-department-items`,
          {
            voucherId: voucherData.id,
            items: visibleRows,
            action,
            sewadarId: sewadarId,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        Swal.fire({
          title: "Success",
          text:
            action == "approve"
              ? "Department items verified successfully!"
              : "Items returned for correction!",
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          navigate("../ReceiptVoucherList");
        });
      } catch (error) {
        console.error("Approval error:", error);
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Something went wrong",
          icon: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    };
    return (
      <div className="  formcontainer mt-5">
        {isLoading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{ backgroundColor: "rgba(255,255,255,0.8)", zIndex: 9999 }}
          >
            <div
              className="spinner-border text-primary"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <strong className="mt-2">Loading voucher data...</strong>
          </div>
        )}

          <div className="row align-items-end">
            {/* Heading */}
            <div className="col-md-3 d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={() => {
                  navigate("../ReceiptVoucherList");
                }}
              >
                Back
              </button>
              <h5 className="mb-0">Department Receipt Voucher</h5>
            </div> 
            <div className="col-md-8">
              <h6 className="mb-3" style={{fontSize:"16px",fontWeight:600}}>{formData?.ledger?.label}</h6>
            </div>
          </div>
      

        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${
                activeTab === "receiptInfo" ? "active" : ""
              }`}
              onClick={() => setActiveTab("receiptInfo")}
            >
              Receipt Info
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${
                activeTab === "inventoryInfo" ? "active" : ""
              }`}
              onClick={() => setActiveTab("inventoryInfo")}
            >
              Inventory Info
            </button>
          </li>
        </ul>

        <div className="tab-content mt-4">
          {activeTab == "receiptInfo" && (
            <div
              className={`tab-pane fade ${
                activeTab === "receiptInfo" ? "show active" : ""
              }`}
              id="receiptInfo-tab"
            >
              <form>

                <div className="row">
                
                  <div className="col-md-2">
              <label htmlFor="documentNo" className="form-label">
                Inward Memo No.:
              </label>
              <input
    type="text"
    id="documentNo"
    className={`form-control ${
      isDocumentNoInvalid ? "border border-danger" : ""
    }`}
    value={formData.documentNo}
    disabled={!isSeriesAvailable} // 🔒 DISABLE IF NO SERIES
    placeholder={
      !isSeriesAvailable
        ? `No series assigned for ${sewadarOf}`
        : "Enter Inward Memo No"
    }
    onChange={(e) => {
      handleChallanChange("documentNo", e.target.value);
      setIsDocumentNoInvalid(false);
    }}
    onBlur={() => {
      if (!seriesRange || !formData.documentNo) return;

      const enteredNo = Number(formData.documentNo);

      if (
        enteredNo < Number(seriesRange.startingNo) ||
        enteredNo > Number(seriesRange.endingNo)
      ) {
        setIsDocumentNoInvalid(true);

        // ❌ erase invalid value
        setFormData((prev) => ({
          ...prev,
          documentNo: "",
        }));

        Swal.fire({
          icon: "error",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          text: `Inward Memo No for ${sewadarOf} must be between ${seriesRange.startingNo} and ${seriesRange.endingNo}`,
        });
      } else {
        setIsDocumentNoInvalid(false);
      }
    }}
  />



            </div>  
            <div className="col-md-2">
              <label htmlFor="documentDate" className="form-label">
              Inward Memo Date:
              </label>
              <input
                type="date"
                id="documentDate"
                className="form-control"
                value={
                  formData?.documentDate
                    ? moment(formData.documentDate).format("YYYY-MM-DD")
                    : (voucherData?.documentDate && !isClone)? moment(voucherData.documentDate).format("YYYY-MM-DD") :""
                }
                onChange={(e) =>
                  handleChallanChange("documentDate", e.target.value)
                }
              />
            </div>
                <div className="col-md-2">
              <label className="form-label">Came From</label>
              <Select
                name="cameFrom"
                value={ledgerGroups.find(
                  (option) => option.value == formData.cameFrom
                )}
                onChange={(selectedOption) =>
                  handleChallanChange("cameFrom", selectedOption)
                }
                options={ledgerGroups}
                placeholder="Select Came From"
                isClearable
              />
            </div>
                  {formData?.cameFrom == "Not Known" ||
                  formData?.cameFrom == "Sangat" ||
                  formData?.cameFrom == "Sewadar" ? (
                    <>
                      <div className="col-md-4">
                        <label className="form-label">Sewadar/Sangat Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.ledgerName || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              ledgerName: e.target.value,
                              ledger: null, // Clear the select value
                            })
                          }
                          placeholder={`Enter  Name`}
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Mobile No</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.sewadarSangatMobile || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sewadarSangatMobile: e.target.value,
                            })
                          }
                          placeholder="Mobile No"
                        />
                      </div>
                    </>
                  ) : (
                    <div className="col-md-6">
                      <label className="form-label">Ledger</label>
                      <Select
                        options={ledgerOptions}
                        value={formData.ledger}
                        onChange={(option) =>
                          handleChallanChange("ledger", option)
                        }
                        isClearable
                      />
                    </div>
                  )}

      
            

                  <div className="col-md-3">
                    <label className="form-label">Purpose</label>
                    <Select
                      options={purposeOptions}
                      value={formData?.purpose}
                      onChange={(option) =>
                        handleChallanChange("purpose", option)
                      }
                      placeholder="Select Purpose"
                      isClearable
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">On Account</label>
                    <Select
                      options={onAccountOptions}
                      value={formData?.onAccount}
                      onChange={(option) =>
                        handleChallanChange("onAccount", option)
                      }
                      placeholder="Select On Account"
                      isClearable
                    />
                  </div>
                
                    <div className="col-md-6">
                      <label className="form-label">Projects</label>
                      <Select
                        options={projectOptions}
                        value={formData?.selectedProjects}
                        onChange={(selectedOptions) =>
                          handleChallanChange("selectedProjects", selectedOptions)
                        }
                        isMulti
                        placeholder="Select Projects"
                      />
                    </div>
              
                    <div className="col-md-3">
                      <label className="form-label">Inventory</label>
                      <Select
                        options={goodsOptions}
                        value={goodsOptions.find(
                          (option) => option.value === formData.receivedGoods
                        )}
                        onChange={(option) => {
                          handleChallanChange(
                            "receivedGoods",
                            option ? option.value : null
                          );
                        }}
                      />
                    </div>
                
                          <div className="col-md-3">
                    <label className="form-label">Vehicle Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="vehicleNo"
                      value={formData?.vehicleNo || ""}
                      onChange={(e) =>
                        handleChallanChange("vehicleNo", e.target.value)
                      }

                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Remarks</label>
                    <input
                      type="text"
                      className="form-control"
                      name="consolidatedRemarks"
                      value={formData?.consolidatedRemarks || ""}
                      onChange={(e) =>
                        handleChallanChange("consolidatedRemarks", e.target.value)
                      }
                    />
                  </div>

                  
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={activeTab === "receiptInfo"}
                    onClick={() => setActiveTab("receiptInfo")}
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setActiveTab("inventoryInfo")}
                  >
                    Next
                  </button>
                </div>
              </form>
            </div>
          )}

          {activeTab == "inventoryInfo" && (
            <div>
              {inventoryRows.map((row, index) => {
                const selectedInventory = inventoryOptions.find(
                  (option) => option.value == row.item
                );
                const selectedDepartment = departments.find(
                  (dep) => dep.value == row.department
                );

                // Determine if the current row belongs to user's department
                const isUserDepartment = row.department == sewadarOf;
                const isNewRow =
                  !row.id || voucherData == undefined || !row.isFromVoucherData;
                const showDeleteButton =
                  isNewRow ||
                  ((role == "Main Incharge" ||
                    role == "Approver" ||
                    role == "Authorized Person") &&
                    voucherData?.createdBy == sewadarId);

                // Determine if the row should be editable
                const isEditable =
                  voucherData?.createdBy == sewadarId ||
                  ((role == "Main Incharge" || role == "Approver") &&
                    isUserDepartment) ||
                  isNewRow ||
                  role == "Authorized Person";

                return (
                  <div
                    key={row.id || `new-${index}`}
                    className="border rounded p-3 mb-4 bg-light shadow-sm"
                  >
                    <div className="row g-2 align-items-end">
                      <div className="col-md-1">
                        <label className="form-label">S.No</label>
                        <input
                          type="number"
                          className="form-control"
                          value={index + 1}
                          disabled
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">Department</label>
                        <Select
                          options={departments}
                          value={selectedDepartment}
                          onChange={(option) => {
                            handleRowChange(
                              row.id,
                              "department",
                              option ? option.value : ""
                            );
                          }}
                          isDisabled={
                            voucherData?.createdBy != sewadarId &&
                            voucherData && !isClone &&
                            (role == "Main Incharge" ||
                              role == "Approver" ||
                              role == "Authorized Person") &&
                            !isNewRow 
                          } // Disable
                          isClearable={
                            role != "Main Incharge" ||
                            role != "Authorized Person" ||
                            role != "Approver"
                          }
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Item Name</label>
                        <Select
                          options={getFilteredInventoryOptions(row.department)}
                          value={
                            row.item
                              ? inventoryOptions.find((i) => i.value == row.item)
                              : null
                          }
                          onChange={(option) =>
                            handleRowChange(
                              row.id,
                              "item",
                              option ? option.value : ""
                            )
                          } // Pass whole option
                          placeholder="Select Item"
                          isClearable
                          isDisabled={
                            !(isClone ||isNewRow || voucherData?.createdBy == sewadarId)
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Returnable</label>
                        <Select
                          options={returnableOptions}
                          value={returnableOptions.find(
                            (opt) => opt.value == row.returnable
                          )}
                          onChange={(option) =>
                            handleRowChange(
                              row.id,
                              "returnable",
                              option ? option.value : ""
                            )
                          }
                          isClearable
                          isDisabled={row.disableReturnable || !isEditable}
                        />
                      </div>

                      <div className="col-md-1">
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={addRow}
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                          {showDeleteButton && (
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => deleteRow(row.id)}
                              disabled={inventoryRows.length == 1}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-md-1">
                        <input
                          type="number"
                          className="form-control"
                          value={index + 1}
                          disabled
                          style={{ visibility: "hidden" }}
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">Document Qty</label>
                        <input
                          type="number"
                          className="form-control"
                          value={row.challanQty || ""}
                          onChange={(e) =>
                            handleRowChange(row.id, "challanQty", e.target.value)
                          }
                          placeholder="Challan Quantity"
                          disabled={
                            voucherData?.createdBy != sewadarId && !isNewRow && !isClone
                          }
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">Recd Qty</label>
                        <input
                          type="number"
                          className="form-control"
                          value={row.recdQty || ""}
                          onChange={(e) =>
                            handleRowChange(row.id, "recdQty", e.target.value)
                          }
                          placeholder="Received Quantity"
                          disabled={!isEditable}
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">Difference</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            row.challanQty && row.recdQty
                              ? parseFloat(row.challanQty) === parseFloat(row.recdQty)
                                ? "0.00"
                                : parseFloat(row.challanQty) > parseFloat(row.recdQty)
                                ? `Short: ${
                                    (parseFloat(row.challanQty) - parseFloat(row.recdQty)).toFixed(2)
                                  }`
                                : `Excess: ${
                                    (parseFloat(row.recdQty) - parseFloat(row.challanQty)).toFixed(2)
                                  }`
                              : ""
                          }                        
                          placeholder="Difference"
                          disabled
                        />
                      </div>

                      <div className="col-md-2">
                        <label className="form-label">UOM</label>
                        <input
                          type="text"
                          className="form-control"
                          value={row.uom || ""}
                          placeholder="UOM"
                          disabled
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Remarks</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Remarks"
                          value={row.remarks}
                          onChange={(e) =>
                            handleRowChange(row.id, "remarks", e.target.value)
                          }
                          disabled={!isEditable}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="d-flex justify-content-between">
                <div className=" gap-2 mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setActiveTab("receiptInfo")}
                  >
                    Previous
                  </button>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                  {voucherData == undefined || isClone ||
                  voucherData?.createdBy == sewadarId ? (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => handleSubmit("Draft at user level")}
                    >
                      Save as Draft
                    </button>
                  ) : (
                    ""
                  )}

                  {voucherData == undefined || isClone ||
                  voucherData?.createdBy == sewadarId ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => handleSubmit("Verification Pending")}
                    >
                      Send for Verification
                    </button>
                  ) : (
                    ""
                  )}

                  {(role == "Main Incharge" ||
                    role == "Approver" ||
                    role == "Authorized Person") &&
                    voucherData && !isClone &&
                    voucherData?.receiptStatus != "Draft at user level" &&
                    voucherData?.createdBy != sewadarId &&
                    inventoryRows.some((row) => row.department == sewadarOf) && (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => handleDepartmentApproval("approve")}
                        disabled={
                          !voucherData || voucherData.status == "approved"
                        }
                      >
                        Approve Department Items
                      </button>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  export default DepartmentReceiptVoucher;
